
import { IDateRange } from '@containers/calendar/calendar.helpter';
import { ISchedule, IScheduleEntry, IScheduleTemplate, TemplateName } from '@app-types/websocket/schedule.types';
import { IHandoverSetting, createArrayCopyAndSort, createScheduleSide, findFirstAndLastEntry, makeSideToMatch, mergeAndClean, modifyTimePlace } from '../ScheduleCalc';
import { addDays } from '@helpers/DateHelper';
import TranslateNew from '@translate/TranslateNew';

const tn: TranslateNew = TranslateNew.getInstance();

// days[0] sleeps at A or B on first night of week = MONDAY
const scheduleTemplates: IScheduleTemplate[] = [
    {
        title: TemplateName.ALTERNATING_WEEKS,
        days: [
            "A", "A", "A", "A", "A", "A", "A",
            "B", "B", "B", "B", "B", "B", "B"
        ],
        type: 'AlternatingResidence',
    },
    {
        title: TemplateName.CUSTOM,
        days: ["A", "A", "A", "A", "A", "A", "A","A", "A", "A", "A", "A", "A", "A"],
        type: 'Socializing',
    },
    {
        title: TemplateName.T223,
        days: [
            "A", "A", "B", "B", "A", "A", "A",
            "B", "B", "A", "A", "B", "B", "B"
        ],
        type: 'AlternatingResidence',
    },
    {
        title: TemplateName.T3443,
        days: [
            "A", "A", "A", "B", "B", "B", "B",
            "A", "A", "A", "A", "B", "B", "B"
        ],
        type: 'AlternatingResidence',
    },
    {
        title: TemplateName.T255,
        days: [
            "A", "A", "B", "B", "A", "A", "A",
            "A", "A", "B", "B", "B", "B", "B"
        ],
        type: 'AlternatingResidence',
    },
    {
        title: TemplateName.T3NIGHTSPW,
        days: [
            "B", "B", "B", "B", "A", "A", "A",
            "B", "B", "B", "B", "A", "A", "A",
        ],
        type: 'Socializing',
    },
    {
        title: TemplateName.T2NIGHTSNPW,
        days: [
            "B", "B", "B", "B", "B", "A", "A",
            "B", "B", "B", "B", "B", "A", "A",
        ],
        type: 'Socializing',
    },
    /*{
        title: TemplateName.T6NIGHTS8NIGHTS,
        days: [
            "B", "A", "A", "A", "A", "A", "A",
            "B", "B", "B", "B", "B", "B", "B",
        ],
        type: 'Socializing',
    },
    {
        title: TemplateName.T5NIGHTS9NIGHTS,
        days: [
            "B", "B", "A", "A", "A", "A", "A",
            "B", "B", "B", "B", "B", "B", "B",
        ],
        type: 'Socializing',
    },
    {
        title: TemplateName.T4NIGHTS10NIGHTS,
        days: [
            "B", "B", "B", "A", "A", "A", "A",
            "B", "B", "B", "B", "B", "B", "B",
        ],
        type: 'Socializing',
    },*/
    {
        title: TemplateName.T3NIGHTS11NIGHTS,
        days: [
            "B", "B", "B", "B", "A", "A", "A",
            "B", "B", "B", "B", "B", "B", "B",
        ],
        type: 'Socializing',
    },
    {
        title: TemplateName.T2NIGHTS12NIGHTS,
        days: [
            "B", "B", "B", "B", "B", "A", "A",
            "B", "B", "B", "B", "B", "B", "B",
        ],
        type: 'Socializing',
    },
];


const applyChanges = (schedule: ISchedule, selectedDays: IDateRange[], template: IScheduleTemplate, shift: number,
    parentAPickup:IHandoverSetting[], parentBPickup:IHandoverSetting[], localization:'en'|'se'): ISchedule => {

    if (selectedDays.length !== 1) {
        return schedule;
    }


    const newSchedule: ISchedule = {
        id: schedule.id,
        lastHandover: schedule.lastHandover,
        status: schedule.status,
        name: schedule.name,
        school: schedule.school,
        data: {
            children: schedule.data.children,
            parentA: schedule.data.parentA,
            parentB: schedule.data.parentB,
            scheduleEntriesParentA: {},
            scheduleEntriesParentB: {},
        }
    }

    let index = ((new Date(selectedDays[0].start)).getDay() - 1);
    if (index === -1) { index = 6; }

    if (localization === 'en') {
        (new Date(selectedDays[0].start)).getDay();
    }

    let templateDays:Array<"A"|"B"> = JSON.parse(JSON.stringify(template.days));

    if (shift > 0) {
        const doShift = Math.min(shift, templateDays.length-1);
        const endPart = templateDays.splice(templateDays.length - doShift, doShift);
        templateDays = endPart.concat(templateDays);
    } else if (shift < 0) {
        const doShift = Math.min((-shift), templateDays.length-1);
        const firstPart = templateDays.splice(0, doShift);
        templateDays = templateDays.concat(firstPart);
    }

    const startSide = templateDays[index%templateDays.length];

    if (startSide === "A") {
        const modifiedEntries = mergeAndClean(
            modifyTimePlace(
                addTemplate(
                    createArrayCopyAndSort(schedule.data.scheduleEntriesParentA), 
                    selectedDays, templateDays, shift, startSide),
            selectedDays,parentAPickup,parentBPickup,1000*60*60*24));
        const foundEntries = findFirstAndLastEntry(schedule.data.scheduleEntriesParentB);
        const matchingEntries = makeSideToMatch(modifiedEntries, foundEntries.firstEntry, foundEntries.lastEntry);
        newSchedule.data.scheduleEntriesParentA = createScheduleSide(modifiedEntries);
        newSchedule.data.scheduleEntriesParentB = createScheduleSide(matchingEntries);
    } else {
        const modifiedEntries = mergeAndClean(
            modifyTimePlace(
                addTemplate(
                    createArrayCopyAndSort(schedule.data.scheduleEntriesParentB), 
                    selectedDays, templateDays, shift, startSide),
            selectedDays,parentAPickup,parentBPickup,1000*60*60*24));
        const foundEntries = findFirstAndLastEntry(schedule.data.scheduleEntriesParentA);
        const matchingEntries = makeSideToMatch(modifiedEntries, foundEntries.firstEntry, foundEntries.lastEntry);
        newSchedule.data.scheduleEntriesParentB = createScheduleSide(modifiedEntries);
        newSchedule.data.scheduleEntriesParentA = createScheduleSide(matchingEntries);    
    }


    if (newSchedule.name === undefined || newSchedule.name.length === 0) {
        newSchedule.name = tn.lang.calendarTemplateName(template.title);
    }

    return newSchedule;
}

const addTemplate = (side: IScheduleEntry[], selectedDays: IDateRange[], templateDays: Array<"A"|"B">, 
    shift:number, parent: "A" | "B"): IScheduleEntry[] => {


    // remove all dates inside range
    if (selectedDays.length !== 1) {
        return side;
    }

    const start = new Date(selectedDays[0].start);
    const end = new Date(selectedDays[0].end);

    start.setHours(12);
    start.setMinutes(0);
    start.setSeconds(0);
    start.setMilliseconds(0);
    end.setHours(12);
    end.setMinutes(0);
    end.setSeconds(0);
    end.setMilliseconds(0);

    const startTime = start.getTime();
    const endTime = end.getTime();

    const newSide: IScheduleEntry[] = [];

    let id = 1;
    if (side.length > 0) {
        id = side.reduce((prev, current) => ((prev && prev.id > current.id) ? prev : current)).id + 1;
    }
    


    for (const entry of side) {
        if (entry.endTime < startTime || entry.startTime > endTime) { // outside of changed days
            newSide.push(entry)
        } else if (entry.startTime >= startTime && entry.endTime <= endTime) { // inside, just remove it 
            continue;
        } else if (entry.startTime < startTime && entry.endTime > endTime) { // entry is bigger than selection. split it.
            newSide.push({ 
                id,
                startTime:endTime,
                startAtSchool:false,
                endTime:entry.endTime,
                endAtSchool:entry.endAtSchool,
                endLoc:entry.endLoc
            });
            id++;
            entry.endTime = startTime;
            entry.endAtSchool = false;
            entry.endLoc = undefined;
            newSide.push(entry);
        } else if (entry.startTime < startTime && entry.endTime >= startTime) { // on border modify it then add
            entry.endTime = startTime;
            entry.endAtSchool = false;
            entry.endLoc = undefined;
            newSide.push(entry);
        } else if (entry.startTime <= endTime && entry.endTime > endTime) { // on border modify it then add
            entry.startTime = endTime;
            entry.startAtSchool = false;
            entry.startLoc = undefined;
            newSide.push(entry);
        } 
    }


    let spinDate = new Date(startTime);
    let index = (spinDate.getDay() - 1);
    if (index === -1) { index = 6; }

    let startDay: number | undefined;
    while (spinDate.getTime() < endTime) {
        const tonightIsAt = templateDays[index % templateDays.length];
        if (tonightIsAt === parent) {
            if (startDay === undefined) {
                startDay = spinDate.getTime();
            }
        } else {
            if (startDay !== undefined) {
                newSide.push({ startTime: startDay, startAtSchool: false, endTime: spinDate.getTime(), endAtSchool: false, id })
                id++;
            }
            startDay = undefined;
        }

        spinDate = addDays(spinDate, 1);
        index++;
    }
    if (startDay !== undefined) {
        newSide.push({ startTime: startDay, startAtSchool: false, endTime: spinDate.getTime(), endAtSchool: false, id })
        id++;
    }

    newSide.sort((a, b) => a.startTime - b.startTime);

    return newSide;
}

export { applyChanges, scheduleTemplates };


// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/editActions/Wizard/WizardCalc.ts